export default function initAnimateProgress() {
  const isPresent = document.querySelector(".completed");
  if (!isPresent) {
    return;
  }

  // Callback function for the Intersection Observer
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Get all .completed divs inside the intersecting .project-card-timeline
        const completedDivs = entry.target.querySelectorAll(".completed");

        completedDivs.forEach((div, index) => {
          // Delay (in ms) increases with each .completed div
          const delay = index * 80; // 0.05s delay converted to milliseconds

          setTimeout(() => {
            div.classList.add("animate");
          }, delay);
        });

        // Optionally, unobserve the target if animation should only happen once
        observer.unobserve(entry.target);
      }
    });
  };

  // Options for the Intersection Observer
  const observerOptions = {
    root: null, // null means the viewport
    threshold: 0.1, // Callback is executed when 10% of the target is visible
  };

  // Creating the Intersection Observer
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // Observing all .project-card-timeline elements
  document.querySelectorAll(".project-card-timeline").forEach((element) => {
    observer.observe(element);
  });
}
